// store/menuSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isChatCheckOpen: false,
  //translate: '-100vw,0,0',
};

const chatCheckSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    openChatCheck: (state) => {
      state.isChatCheckOpen = true;
     // state.translate = '0,0,0';
    },
    closeChatCheck: (state) => {
      state.isChatCheckOpen = false;
     // state.translate = '-100vw,0,0';
    },
    toggleChatCheck: (state) => {
      state.isChatCheckOpen = !state.isChatCheckOpen;
     // state.translate = state.isOpen ? '0,0,0' : '-100vw,0,0';
    },
  },
});

export const { openChatCheck, closeChatCheck, toggleChatCheck } = chatCheckSlice.actions;
export default chatCheckSlice.reducer;
